import React from 'react'
import Label from "components/general/Label"
import { ColumnRank, ColumnStartOrder, ColumnWarnings, ColumnNoc, ColumnResult, ColumnRecords, ColumnQualification, ColumnName, ColumnExpander } from "components/common/TableColumns"




export const CellTieRule = React.memo(({ extendedResults, rank }) => {
    let rule = extendedResults.filter(row => (row.er_code === 'RULE')).map((val) => { return (val.er_value) });
    let tie = extendedResults.filter(row => (row.er_code === 'MS')).map((val) => { return (val.er_value) });
    let resp = rule.length > 0 ? rule : tie.length > 0 ? '(' + tie + ')' : ''
    return (resp)
});


export function TableColumns() {
    return (
        [
            ColumnRank({}),
            ColumnStartOrder({ label: 'HeaderLane' }),
            ColumnNoc({}),
            ColumnName({ label: 'HeaderTeam' }),
            ColumnWarnings({}),
            {
                Header: <Label data='HeaderReaction' />,
                accessor: 'extendedResults',
                className: 'text-end',
                headerClassName: 'text-end w-5',
                id: 'RT',
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? props.cell.row.original.extendedResults.filter(row => row.er_code === 'REACT_TIME').map((val) => { return (val.er_value) })
                        : ''
                )
            },
            ColumnResult({}),
            {
                accessor: 'extendedResults',
                id: 'TieRules',
                className: '',
                headerClassName: 'w-5',
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? <CellTieRule extendedResults={props.cell.row.original.extendedResults}></CellTieRule>
                        : ''
                )
            },
            ColumnRecords({}),
            ColumnQualification({}),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}


export default TableColumns
